import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

import { isLocalEnv } from '@/config/runtime-env'
import type { RouterContext } from '@/router'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  wrapInSuspense: true,
  pendingMinMs: 0,
})

function Root() {
  return (
    <>
      <HeadContent />
      <Outlet />
      {isLocalEnv() && <TanStackRouterDevtools />}
    </>
  )
}
